import { createFileRoute, redirect } from "@tanstack/react-router"
import { useAuthStore } from "@/store/auth.store"
import { OrderDetailsPage as BuyerOrderDetailsPage } from "@/components/dashboard/buyer/pages/orders/OrderDetailsPage"
import { OrderDetailsPage as SellerOrderDetailsPage } from "@/components/dashboard/seller/pages/orders/OrderDetailsPage"
import { OrderDetailsPage as AdminOrderDetailsPage } from "@/components/dashboard/admin/pages/orders/OrderDetailsPage"

export const Route = createFileRoute("/orders/$orderId")({
  beforeLoad: ({ params }) => {
    const { user } = useAuthStore.getState()
    const role = user?.role?.toUpperCase()
    if (role === "BUYER") {
      throw redirect({
        to: "/dashboard/orders/$orderId",
        params: { orderId: params.orderId },
      })
    }
  },
  component: OrderDetailRoute,
})

function OrderDetailRoute() {
  const { orderId } = Route.useParams()
  const role = useAuthStore((s) => s.user?.role)
  if (role === "SELLER") return <SellerOrderDetailsPage orderId={orderId} />
  if (role === "ADMIN") return <AdminOrderDetailsPage orderId={orderId} />
  return <BuyerOrderDetailsPage orderId={orderId} />
}
